module.exports = __webpack_public_path__ + "img/位图(2).ef070fa7.png";